<app-table
  class="table"
  [dataSource]="pdsAbo"
  [TableColumns]="pdsAboColumns"
></app-table>
